const AppendScript = () => {
  const script = document.createElement('script')
  script.src = '/changes.js'
  script.async = true
  document.body.appendChild(script)
  return <span onClick={() => window.__changes_showChanges()}>🔥</span>
}

export default AppendScript